"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CheckboxInput = _interopRequireDefault(require("../../Controls/CheckboxInput"));

var _RadioInput = _interopRequireDefault(require("../../Controls/RadioInput"));

var _RangeInput = _interopRequireDefault(require("../../Controls/RangeInput"));

var _RankInput = _interopRequireDefault(require("../../Controls/RankInput"));

var _TextInput = _interopRequireDefault(require("../../Controls/TextInput"));

var _SelectInput = _interopRequireDefault(require("../../Controls/SelectInput"));

var _RatingInput = _interopRequireDefault(require("../../Controls/RatingInput"));

var _CCExpirationInput = _interopRequireDefault(require("../../Controls/CCExpirationInput"));

var _CCNumberInput = _interopRequireDefault(require("../../Controls/CCNumberInput"));

var _TypeaheadInput = _interopRequireDefault(require("../../Controls/TypeaheadInput"));

var _default = {
  radio: _RadioInput["default"],
  text: _TextInput["default"],
  typeahead: _TypeaheadInput["default"],
  tel: _TextInput["default"],
  email: _TextInput["default"],
  password: _TextInput["default"],
  range: _RangeInput["default"],
  checkbox: _CheckboxInput["default"],
  rank: _RankInput["default"],
  select: _SelectInput["default"],
  rating: _RatingInput["default"],
  ccExpiration: _CCExpirationInput["default"],
  ccNumber: _CCNumberInput["default"]
};
exports["default"] = _default;